import { useRoundStatus } from '@/hooks/shared/useRoundStatus';
import { NoFeeForTopUpNewInvestors } from './index';

export const useNoFeeForTopUpNewInvestor = () => {
  const { status } = useRoundStatus();
  if (!status || status?.has_previously_invested) return null;
  return <NoFeeForTopUpNewInvestors />;
};
